import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import Select from 'react-select';
import DatePicker from 'react-datepicker';
import Toggle from 'react-toggle';
import InputMask from 'react-input-mask';
import getLocale from '../../i18n/getLocale';

class StaffFlightHourSearch extends Component {
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      situation: 0,
      company: 0,
      data_search: [],
      aircraft_models_list: [],
      staff_list: [],
      totals: [],
      fb: null,
      type: 0,
      date_start: null,
      date_finish: null,
      fb_list: [
        {value: "DC", label: "DC"},
        {value: "IN", label: "IN"},
        {value: "2P", label: "2P"},
        {value: "1P", label: "1P"},
        {value: "CM", label: "CM"},
        {value: "PS", label: "PS"},
      ],
      type_list: [
        {value: 0, label: this.locale.HorasDeVoo.VisualizarHorasDeVoo.opcoesTipo.Sintetica},
        {value: 1, label: this.locale.HorasDeVoo.VisualizarHorasDeVoo.opcoesTipo.Analitica},
      ],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.searchFlightHours = this.searchFlightHours.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleSelectChangeStaffSimple(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeList(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
    this.setState({staff_ids: null});
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleChangeDatePicker (state, date) {
    var change = {};
    change[state] = date.format("DD/MM/YYYY");
    this.setState(change);
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  searchFlightHours(event) {
    event.preventDefault();

    if (this.state.type == 1 && (this.state.date_start === '' || this.state.date_start === null || this.state.date_finish === '' || this.state.date_finish === null)) {
      this.handleAlert(this.locale.HorasDeVoo.VisualizarHorasDeVoo.eNecessarioPreencherDataDeInicioEFimParaPesquisasAnaliticas, 'error', 'open');
    } else {
      this.handleAlert('', '', 'open');
      var datasave = {
        type: this.state.type,
        fb: this.state.fb,
        situation: this.state.situation,
        aircraft_models: this.state.aircraft_models_ids,
        company: this.state.company,
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
      };

      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/tripulante/buscar/horas/voos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({data_search: responseJson.data.main});
            self.setState({totals: responseJson.data.totals});
            self.setState({overlay: {message: '', type: '', status: 'closed'}});
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');

    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/aeronave/modelo/lista/modelos';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({aircraft_models_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }


  render() {
    var self = this;
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.HorasDeVoo.VisualizarHorasDeVoo.titulo}</h3>
      <hr/>
      <form onSubmit={this.searchFlightHours}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.formulario.DataInicial}:</label>
              <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.formulario.DataFinal}:</label>
              <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.formulario.FB}:</label>
              <Select
                className=""
                name="fb"
                value={this.state.fb}
                searchable={true}
                multi={true}
                placeholder={this.locale.HorasDeVoo.VisualizarHorasDeVoo.formulario.placeholder.SelecionarTipo}
                onChange={this.handleSelectChange.bind(this, 'fb')}
                options={this.state.fb_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.formulario.Listagem}:</label>
              <Select
                className=""
                name="type"
                value={this.state.type}
                searchable={true}
                onChange={this.handleSelectChangeList.bind(this, 'type')}
                options={this.state.type_list}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.formulario.Modelo}:</label>
              <Select
                className=""
                name="aircraft_models_ids"
                value={this.state.aircraft_models_ids}
                searchable={true}
                multi={true}
                placeholder={this.locale.HorasDeVoo.VisualizarHorasDeVoo.formulario.placeholder.SelecionarModelosDeAeronave}
                onChange={this.handleSelectChange.bind(this, 'aircraft_models_ids')}
                options={this.state.aircraft_models_list}
              />
            </div>
          </div>
        </div>
        <hr/>
        <div>
          <button type="submit" className="btn btn-success btn-block"><i className="fa fa-fw fa-search"></i> {this.locale.general.pesquisar} </button>
        </div>
      </form>
      <hr/>
      <BootstrapTable data={this.state.data_search} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.semAeronaves}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} hidden={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Data}</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_inscription" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='80'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Matricula}</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_nickname" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='160'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Apelido}</TableHeaderColumn>
        <TableHeaderColumn dataField="aircraft_model" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Modelo}</TableHeaderColumn>
        <TableHeaderColumn dataField="fb" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.FB}</TableHeaderColumn>
        <TableHeaderColumn dataField="simulator_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Simulador}</TableHeaderColumn>
        <TableHeaderColumn dataField="total_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Total}</TableHeaderColumn>
        <TableHeaderColumn dataField="ifr_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.IFR}</TableHeaderColumn>
        <TableHeaderColumn dataField="noturno_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Noturno}</TableHeaderColumn>
        <TableHeaderColumn dataField="app" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.APP}</TableHeaderColumn>
        <TableHeaderColumn dataField="daytime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Diu}</TableHeaderColumn>
        <TableHeaderColumn dataField="nighttime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Not}</TableHeaderColumn>
        {this.state.type === 0 ?
          <TableHeaderColumn dataField="freight_ex_total_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.CgExt}</TableHeaderColumn>
          :
          <TableHeaderColumn dataField="freight_ex_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.CgExt}</TableHeaderColumn>
        }
      </BootstrapTable>
      <hr/>
      <h4>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tituloTotais}</h4>
      <hr/>
      <BootstrapTable data={this.state.totals} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.semAeronaves}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
        <TableHeaderColumn dataField="id" isKey={true} hidden={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_inscription" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='80'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.Matricula}</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_nickname" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='160'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.Apelido}</TableHeaderColumn>
        <TableHeaderColumn dataField="aircraft_model" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.Modelo}</TableHeaderColumn>
        <TableHeaderColumn dataField="total_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.Total}</TableHeaderColumn>
        <TableHeaderColumn dataField="ifr_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.IFR}</TableHeaderColumn>
        <TableHeaderColumn dataField="noturno_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.Noturno}</TableHeaderColumn>
        <TableHeaderColumn dataField="app" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.APP}</TableHeaderColumn>
        <TableHeaderColumn dataField="daytime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.Diu}</TableHeaderColumn>
        <TableHeaderColumn dataField="nighttime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.Not}</TableHeaderColumn>
      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default StaffFlightHourSearch;



// WEBPACK FOOTER //
// ./src/Components/Staffs/StaffFlightHourSearch.js